export const CONTACT_TYPE = {
  GENERAL: 'general',
  SUPPORT_SERVICE: 'support_service',
  OTHER: 'other',
} as const;

export type ContactType = (typeof CONTACT_TYPE)[keyof typeof CONTACT_TYPE];

export const CONTACT_STATUS = {
  UNHANDLED: 1,
  IN_PROGRESS: 2,
  DONE: 3,
} as const;

export type ContactStatus = (typeof CONTACT_STATUS)[keyof typeof CONTACT_STATUS];

export interface Contact {
  id: number;
  received_at: string;
  reception_number: string;
  contact_type: ContactType;
  company_name: string;
  company_name_kana: string;
  department: string | null;
  position: string | null;
  name: string;
  name_kana: string;
  email: string;
  phone_number: string | null;
  support_service_name: string | null;
  content: string;
  status: ContactStatus;
  memo: string | null;
}
